import type { ReactNode } from "react";
import { useLocale } from "../i18n/LocaleProvider";
import styles from "./Screen.module.css";

interface ScreenProps {
  title: string;
  back?: () => void;
  action?: ReactNode;
  children: ReactNode;
}

export function Screen({ title, back, action, children }: ScreenProps) {
  const { t } = useLocale();
  return (
    <main className={styles.screen}>
      <header className={styles.header}>
        {(back || action) && (
          <div className={styles.bar}>
            {back && (
              <button type="button" className={styles.back} onClick={back} aria-label={t.common.back}>
                <svg width="12" height="20" viewBox="0 0 12 20" aria-hidden="true">
                  <path d="M10.5 1.5 2 10l8.5 8.5" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            )}
            <span className={styles.spacer} />
            {action}
          </div>
        )}
        <h1 className={styles.title}>{title}</h1>
      </header>
      <div className={styles.body}>{children}</div>
    </main>
  );
}
